import { useState } from 'react'
import './musicianLocation.css'
import EditLocationModal from './editLocationModal'
import { useAtom } from 'jotai'
import { locationFormattedStringAtom } from '../../../State/Musician/locationFormattedStringAtom'
import { useAuth0 } from '@auth0/auth0-react'
import userClient from '../../../Api/Lirari/Clients/userClient'
import { locationIdAtom } from '../../../State/Musician/locationIdAtom'
import { locationGeometryAtom } from '../../../State/Musician/locationGeometryAtom'
import { myUserAtom } from '../../../State/Musician/myUserAtom'
import { useParams } from 'react-router-dom'
import { unauthenticatedUserAtom } from '../../../State/Musician/unauthenticatedUserAtom'

const MusicianLocation = ({ editMode }: { editMode: boolean }) => {
  const [isModalOpen, setIsModalOpen] = useState(false)
  const [locationFormattedString] = useAtom(locationFormattedStringAtom)
  const [locationId] = useAtom(locationIdAtom)
  const [locationGeometry] = useAtom(locationGeometryAtom)
  const [myUser, setMyUser] = useAtom(myUserAtom)
  const [unauthenticatedUser] = useAtom(unauthenticatedUserAtom)
  const { isAuthenticated, getAccessTokenSilently } = useAuth0()
  const { uid: userId } = useParams()

  const userProfile =
    userId == myUser.id
      ? myUser
      : userId == unauthenticatedUser.id
        ? unauthenticatedUser
        : { locationFormattedString: 'Kufor Nimeh, Palestine' }

  const locationName = userProfile
    ? userProfile.locationFormattedString?.split(',')
    : locationFormattedString?.split(',')

  const showModal = () => {
    setIsModalOpen(true)
  }

  const handleOk = async () => {
    setIsModalOpen(false)
    if (isAuthenticated) {
      const token = await getAccessTokenSilently({
        authorizationParams: {
          scope: 'user:all',
        },
      })

      await userClient.updateUser(
        userId!,
        {
          locationId,
          locationFormattedString,
          locationGeometry: {
            type: 'Point',
            coordinates: [locationGeometry.lng, locationGeometry.lat],
          },
        },
        token,
      )

      setMyUser({ ...myUser, locationFormattedString })
    }
  }

  return (
    <div
      className={`${editMode ? 'cursor-pointer' : ''} musician-location-wrapper lg:justify-start justify-center`}
      onClick={() => (editMode && !isModalOpen ? showModal() : null)}
    >
      {locationName && locationName.length > 0 ? (
        <>
          {locationName.length >= 3 ? (
            <div className="musician-location">
              <p className="location-name">
                {locationName[0].trim()}, {locationName[1]?.trim()},
              </p>
              <p className="location-name">
                {locationName[2]?.trim() == 'Israel' ? 'Palestine' : locationName[2]?.trim()}
              </p>
            </div>
          ) : (
            <div className="musician-location lg:mt-0 mt-[2vh]">
              <p className="location-name lg:text-start text-center"> {locationName[0] && `${locationName[0]},`}</p>
              <p className="location-name lg:text-start text-center">
                {locationName[1]?.trim() == 'Israel' || (!locationName[1] && locationName[0])
                  ? 'Palestine'
                  : locationName[1]?.trim()}
              </p>
            </div>
          )}
        </>
      ) : (
        <p>Enter location</p>
      )}

      <EditLocationModal isModalOpen={isModalOpen} handleOk={handleOk} />
    </div>
  )
}

export default MusicianLocation
